import { render, staticRenderFns } from "./u-btn-arrow-flat-tile.vue?vue&type=template&id=6e72dd18&scoped=true&"
import script from "./u-btn-arrow-flat-tile.vue?vue&type=script&lang=js&"
export * from "./u-btn-arrow-flat-tile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e72dd18",
  null
  
)

export default component.exports